export default __webpack_public_path__ + "static/media/Round_Guide_disable.e319f5d4.svg";